module.exports = __webpack_public_path__ + "img/rede_logica.e4ee1956.svg";